/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState,useEffect } from "react"; 
import { useParams } from "react-router-dom";
import axios from 'axios';

import Header from "../../components/includes/Header";
import HeaderTitle from "../../components/includes/HeaderTitle";

import { LoginAfterCheckLogin,unescapeHtml } from "../../components/common/Common";

import "../../css/style.css";

const Conditions = () => {
  LoginAfterCheckLogin(1);  //로그인 상태 점검
  
  const { conMode } = useParams();  //1:이용약관,2:개인정보취급방침
  //약관
  const [varCurrentTerm,setCurrentTerm] = useState(null);   
  const [varTerms,setTerms] = useState({services_title:"이용약관",privacy_title:"개인정보취급방침",services:"",privacy:""});

  //약관정보 읽어오기
  const getTermInformation = async () => {
    await axios.post(`${process.env.REACT_APP_HOST}/_get_terms`).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const termObj = datas.results;
        termObj.services = unescapeHtml(termObj.services);
        termObj.privacy = unescapeHtml(termObj.privacy);
        setTerms({...varTerms,services:termObj.services,privacy:termObj.privacy});
      }
    });
  }
  //최초실행부
  useEffect(() => {
    getTermInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    var sobjName = "services";
    if(Number(conMode)===2) sobjName = "privacy";
    setCurrentTerm(sobjName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conMode]);
  
  return (
    <div className="vh-container">
      <Header varGoToMain={true} />
      <div className="vh-content">
        <HeaderTitle varPageTitle={varTerms[varCurrentTerm+"_title"]}/>
        <div className="vh-content-body">
          <div className="private-details">{varTerms[varCurrentTerm]}</div>
        </div>
      </div>
    </div>
  );
}
export default Conditions;